import React, {Fragment, useState, useEffect} from 'react';
import {Navigate, Route, Routes, useNavigate} from 'react-router-dom';
import Login from './login';
import ListadoDeArticulos from './listado-articulos';
import Articulo from './articulo';
import Home from './home';
import NuevoLinkRegistro from './nuevo-link-registro/Index';
import {connect} from 'react-redux';
import {setToken} from '../../reducer/user-reducer';
import {fetchConfig} from '../../reducer/config-reducer';
import {IntlProvider} from 'react-intl';
import StyleConfig from '../../components/styleConfig';
import Header from '../../components/header';
import Footer from '../../components/Footer';
import EnviarNotificaciones from './notificaciones';
import {Container} from 'reactstrap';
import Users from './users/Index';

const context = require.context('../../lang', true, /.json$/);

interface configObject {
  user: {
    token: string;
  };
  configReducer: {
    siteConfig:any
  };
}
interface AppProps {
  token: string;
  setToken(token: string): null;
  fetchConfig(): any;
  configProp: any;
}

const Index = (props: AppProps) => {
  const {setToken, fetchConfig, configProp} = props;
  const locale = navigator.language;
  const [config, setConfig] = useState<any>(null);
  const navigate = useNavigate();

  const allLanguages: any = {};
  context.keys().forEach((key: any) => {
    const fileName = key.replace('./', '');
    const resource = require(`../../lang/${fileName}`);
    const namespace: string = fileName
      .replace('.json', '')
      .replaceAll('-', '_');
    allLanguages[namespace] = JSON.parse(JSON.stringify(resource));
  });

  useEffect(() => {
    const tokenLocal = localStorage.getItem('token');
    if (!tokenLocal) {
      navigate('/admin/login');
    } else {
      setToken(tokenLocal);
    }
    fetchConfig();
  }, [navigate, setToken, fetchConfig]);

  useEffect(() => {
    if (configProp) {
      setConfig(configProp);
    }
  }, [configProp]);

  return (
    <Fragment>
      {config?.localizationFile && (
        <IntlProvider
          locale={locale}
          messages={allLanguages[config.localizationFile]}
        >
          <Container fluid className="d-flex flex-column m-0 p-0 min-vh-100">
            <Header />
            <Routes>
              <Route path="listar-articulos" element={<ListadoDeArticulos />} />
              <Route
                path="enviar-notificaciones"
                element={<EnviarNotificaciones />}
              />
              <Route path="articulo/:id" element={<Articulo editor={true} />} />
              <Route path="nuevo-articulo" element={<Articulo />} />
              <Route path="login" element={<Login />} />
              <Route path="/home" element={<Home />} />
              <Route path="/usuarios" element={<Users />}/>
              <Route
                path="nuevo-link-registro"
                element={<NuevoLinkRegistro />}
              />
              <Route path="*" element={<Navigate to="/admin/home" replace />} />
            </Routes>
            <Footer />
            <StyleConfig />
          </Container>
        </IntlProvider>
      )}
    </Fragment>
  );
};

const mapStateToProps = (state: configObject) => {
  return {
    token: state.user.token,
    configProp: state.configReducer.siteConfig,
  };
};
export default connect(mapStateToProps, {setToken, fetchConfig})(Index);
